import { Icon } from '../icons/Icon';
import { Avatar, companyShortName, serverSlotOf } from '../ui/Avatar';
import { usePerson } from './bits';
import { useAppEnv, useClientState } from './context';
import { ROLE_LABEL } from './copy';
import { hostOf } from '../format';
import { isMacLike } from './shell';

/** Left rail: company servers, main navigation, admin and profile. */
export function Rail() {
  const env = useAppEnv();
  const me = useClientState((s) => s.me);
  const mePerson = usePerson(me?.id);
  const dndUntil = useClientState((s) => s.dndUntil);
  const dnd = Boolean(dndUntil && new Date(dndUntil).getTime() > env.now().getTime());
  const isAdmin = me?.role === 'owner' || me?.role === 'admin';
  const savedOn = useClientState((s) => s.serverInfo?.capabilities.includes('messages.saved') ?? false);
  return (
    <nav className="rail glass" aria-label="회사 서버와 주 메뉴">
      <div className="srv-list">
        {env.servers.map((s) => {
          const active = s.serverId === env.activeServerId;
          const unread = active ? 0 : (env.serverUnread[s.serverId] ?? 0);
          return (
            <button
              key={s.serverId}
              type="button"
              className={`srv ${serverSlotOf(s.serverId)}${active ? ' active' : ''}`}
              onClick={() => env.switchServer(s.serverId)}
              data-tip={`${s.companyName} · ${hostOf(s.serverUrl)} — 회사별 계정이 분리돼요`}
              data-tip-pos="right"
              aria-label={`${s.companyName} 서버${unread ? `, 안 읽음 ${unread}` : ''}`}
              aria-current={active ? 'true' : undefined}
            >
              {companyShortName(s.companyName)}
              {unread ? <span className="badge">{unread}</span> : null}
            </button>
          );
        })}
        {env.platform.serverRegistry ? (
          <button type="button" className="srv add" onClick={env.addServer} data-tip="회사 서버 추가" data-tip-pos="right" aria-label="회사 서버 추가">
            <Icon name="plus" />
          </button>
        ) : null}
      </div>
      <div className="rail-sep" />
      <div className="rail-nav">
        <button type="button" className="rail-btn on" data-tip="대화" data-tip-pos="right" aria-label="대화" aria-current="page">
          <Icon name="chat" size="lg" />
        </button>
        <button type="button" className="rail-btn" onClick={() => env.openModal({ kind: 'people', mode: 'new' })} data-tip="사람 찾기" data-tip-pos="right" aria-label="사람 찾기">
          <Icon name="users" size="lg" />
        </button>
        <button type="button" className="rail-btn" onClick={() => env.openModal({ kind: 'search' })} data-tip={`검색 (${isMacLike() ? '⌘K' : 'Ctrl K'})`} data-tip-pos="right" aria-label="검색">
          <Icon name="search" size="lg" />
        </button>
        {savedOn ? (
          <button type="button" className="rail-btn" onClick={() => env.openModal({ kind: 'search', tab: 'saved' })} data-tip="저장한 메시지" data-tip-pos="right" aria-label="저장한 메시지">
            <Icon name="note" size="lg" />
          </button>
        ) : null}
        <button type="button" className="rail-btn" onClick={() => env.openModal({ kind: 'settings' })} data-tip="설정·알림" data-tip-pos="right" aria-label="설정">
          <Icon name="gear" size="lg" />
        </button>
      </div>
      <div className="rail-bottom">
        {isAdmin ? (
          <button type="button" className="rail-btn" onClick={() => env.navigate('admin')} data-tip="회사 관리" data-tip-pos="right" aria-label="회사 관리">
            <Icon name="shield" size="lg" />
          </button>
        ) : null}
        <button
          type="button"
          className="me-btn"
          onClick={() => env.openModal({ kind: 'settings' })}
          data-tip={me ? `${me.displayName} · ${ROLE_LABEL[me.role]} · ${me.email}` : undefined}
          data-tip-pos="right"
          aria-label="내 프로필과 상태"
        >
          <Avatar person={mePerson ?? me} noDot />
          {dnd ? (
            <span className="dnd">
              <Icon name="moon" />
            </span>
          ) : null}
        </button>
      </div>
    </nav>
  );
}
